import gql from "graphql-tag";

export const GET_MY_DEALERS_SALE = gql`
  query sales_assign($profile_id: String!) {
    sales_assign(
      where: { profile_id: { _eq: $profile_id } }
      order_by: { assign_profiles: { created_at: desc } }
    ) {
      id
      created_at
      profile_id
      assign_user_id
      assign_profiles {
        assign_region
        profile_id
        name
        company
        email
        has_skiff
        has_seachaser
        has_funchaser
        address
        address2
        city
        zipcode
        country
        region
        phone
        status
        created_at
      }
    }
  }
`;

export const PENDING_BOAT_REQUEST = gql`
  subscription boat_shows($profileIds: [String!]!) {
    boat_shows(
      where: { profile_id: { _in: $profileIds }, status: { _eq: "Pending" } }
      order_by: { created_at: desc }
    ) {
      id
      name
      profile_id
      status
      address
      address2
      city
      zipcode
      region
      country
      description
      brands
      dealer
      created_at
      modified_at
      start_date
      end_date
      site
    }
  }
`;

export const PAST_BOAT_SHOW = gql`
  subscription boat_shows($profileIds: [String!]!) {
    boat_shows(
      where: { profile_id: { _in: $profileIds }, end_date: { _lt: "now()" } }
    ) {
      id
      name
      profile_id
      status
      address
      address2
      city
      zipcode
      region
      country
      description
      created_at
      modified_at
      start_date
      end_date
      site
      dealer
      brands
    }
  }
`;

export const UPCOMING_BOAT_SHOW = gql`
  subscription boat_shows($profileIds: [String!]!) {
    boat_shows(
      where: {
        profile_id: { _in: $profileIds }
        start_date: { _gte: "now()" }
        status: { _eq: "Approved" }
      }
    ) {
      id
      created_at
      modified_at
      profile_id
      name
      dealer
      address
      address2
      city
      region
      description
      zipcode
      country
      brands
      start_date
      end_date
      site
      dealer
    }
  }
`;

export const DEALER_ASSIGN_BOAT = gql`
  mutation insert_dealer_assign_boat(
    $objects: [dealer_assign_boat_insert_input!]!
  ) {
    insert_dealer_assign_boat(objects: $objects) {
      returning {
        id
      }
    }
  }
`;

export const SALES_WARRANTY_REGISTRATION = gql`
  query warranty_registration(
    $where: warranty_registration_bool_exp
    $skip: Int
    $limit: Int
  ) {
    warranty_registration(
      offset: $skip
      limit: $limit
      where: $where
      order_by: { submittedon: desc }
    ) {
      admin_name
      admin_email
      profile_id
      status
      hull_identification_number
      purchase_date
      brand
      model
      first_name
      last_name
      phone
      email
      address
      address2
      city
      region
      country
      zipcode
      motor_details
      accessories
      primary_use
      warranty_id
      submittedon
      id
      is_deleted
      profiles {
        name
      }
    }
    warranty_registration_aggregate(
      where: $where
      order_by: { submittedon: desc }
    ) {
      aggregate {
        totalCount: count
      }
    }
  }
`;

export const getwarrantysales = gql`
  query warranty_registration($profileIds: [String]) {
    warranty_registration(
      order_by: { submittedon: desc }
      where: {
        is_deleted: { _eq: 0 }
        status: { _neq: "Deleted" }
        profile_id: { _in: $profileIds }
      }
    ) {
      admin_name
      admin_email
      profile_id
      status
      hull_identification_number
      purchase_date
      brand
      model
      first_name
      last_name
      phone
      email
      address
      address2
      city
      region
      country
      zipcode
      motor_details
      accessories
      primary_use
      warranty_id
      submittedon
      id
      is_deleted
      profiles {
        name
      }
    }
  }
`;

export const ADD_DEALER_DVR_REPORT = gql`
  mutation insert_dealer_dvr_report(
    $objects: [dealer_dvr_report_insert_input!]!
  ) {
    insert_dealer_dvr_report(objects: $objects) {
      returning {
        id
      }
    }
  }
`;

export const ADD_DVR_OTHER_BRAND = gql`
  mutation insert_dvr_other_brand($objects: [dvr_other_brand_insert_input!]!) {
    insert_dvr_other_brand(objects: $objects) {
      returning {
        id
      }
    }
  }
`;

export const ADD_DVR_OUR_BRAND = gql`
  mutation insert_dvr_our_brand($objects: [dvr_our_brand_insert_input!]!) {
    insert_dvr_our_brand(objects: $objects) {
      returning {
        id
      }
    }
  }
`;

export const SALES_DVR_REPORT = gql`
  subscription dealer_dvr_report($profileIds: [String!]!) {
    dealer_dvr_report(
      where: { profile_id: { _in: $profileIds } }
      order_by: { created_at: desc }
    ) {
      id
      date
      dealership
      contact_name
      phone
      fax
      address
      address_2
      bta
      program
      sales_goal
      whole_sale_units
      whole_sale_dollars
      retail_units
      retail_dollars
      on_order_units
      on_order_dollars
      average_market_share
      bta_current_market_share
      current_deficiency
      correct_deficiency
      carolina_no_of_boats
      sea_chaser_no_of_boats
      advertising_campaign
      profile_id
      created_at
      dvr_comments {
        id
        comment
        profile {
          name
        }
      }
      profile {
        name
      }
      profiles {
        name
        email
        has_skiff
        has_funchaser
        has_seachaser
      }
      dvr_other_brands {
        id
        dealer_dvr_report_id
        description
        qty
      }
      dvr_our_brands {
        id
        dealer_dvr_report_id
        description
        qty
      }
    }
  }
`;

export const DVR_REPORT_BY_ID = gql`
  query dealer_dvr_report_by_pk($id: uuid!) {
    dealer_dvr_report_by_pk(id: $id) {
      id
      date
      dealership
      contact_name
      phone
      fax
      address
      address_2
      bta
      program
      sales_goal
      whole_sale_units
      whole_sale_dollars
      retail_units
      retail_dollars
      on_order_units
      on_order_dollars
      average_market_share
      bta_current_market_share
      current_deficiency
      correct_deficiency
      carolina_no_of_boats
      sea_chaser_no_of_boats
      advertising_campaign
      profile_id
      created_at
      dvr_comments {
        id
        comment
        profile {
          profile_id
          name
        }
      }
      profile {
        profile_id
        name
      }
      profiles {
        profile_id
        name
        email
        has_skiff
        has_funchaser
        has_seachaser
      }
      dvr_other_brands {
        id
        dealer_dvr_report_id
        description
        qty
      }
      dvr_our_brands {
        id
        dealer_dvr_report_id
        description
        qty
      }
    }
  }
`;

export const UPDATE_DVR_REPORT = gql`
  mutation update_dealer_dvr_report(
    $id: uuid!
    $date: date
    $dealership: String!
    $contact_name: String
    $phone: String
    $fax: String
    $address: String
    $address_2: String
    $bta: String
    $program: String
    $sales_goal: String
    $whole_sale_units: Int
    $whole_sale_dollars: Int
    $retail_units: Int
    $retail_dollars: Int
    $on_order_units: Int
    $on_order_dollars: Int
    $average_market_share: Int
    $bta_current_market_share: Int
    $current_deficiency: Boolean
    $correct_deficiency: String
    $carolina_no_of_boats: Int
    $sea_chaser_no_of_boats: Int
    $advertising_campaign: Boolean
  ) {
    update_dealer_dvr_report(
      where: { id: { _eq: $id } }
      _set: {
        date: $date
        dealership: $dealership
        contact_name: $contact_name
        phone: $phone
        fax: $fax
        address: $address
        address_2: $address_2
        bta: $bta
        program: $program
        sales_goal: $sales_goal
        whole_sale_units: $whole_sale_units
        whole_sale_dollars: $whole_sale_dollars
        retail_units: $retail_units
        retail_dollars: $retail_dollars
        on_order_units: $on_order_units
        on_order_dollars: $on_order_dollars
        average_market_share: $average_market_share
        bta_current_market_share: $bta_current_market_share
        current_deficiency: $current_deficiency
        correct_deficiency: $correct_deficiency
        carolina_no_of_boats: $carolina_no_of_boats
        sea_chaser_no_of_boats: $sea_chaser_no_of_boats
        advertising_campaign: $advertising_campaign
      }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_DVR_OTHER_BRAND = gql`
  mutation delete_dvr_other_brand($dealer_dvr_report_id: uuid!) {
    delete_dvr_other_brand(
      where: { dealer_dvr_report_id: { _eq: $dealer_dvr_report_id } }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_DVR_OUR_BRAND = gql`
  mutation delete_dvr_our_brand($dealer_dvr_report_id: uuid!) {
    delete_dvr_our_brand(
      where: { dealer_dvr_report_id: { _eq: $dealer_dvr_report_id } }
    ) {
      affected_rows
    }
  }
`;

export const DEALER_ASSIGN = gql`
  mutation insert_sales_assign($objects: [sales_assign_insert_input!]!) {
    insert_sales_assign(objects: $objects) {
      returning {
        id
      }
    }
  }
`;

export const DELETE_DEALER_ASSIGN = gql`
  mutation delete_sales_assign($profile_id: String!) {
    delete_sales_assign(where: { profile_id: { _eq: $profile_id } }) {
      affected_rows
    }
  }
`;

export const DELETE_DEALER_SALES_ASSIGN = gql`
  mutation delete_sales_assign($conditions: [sales_assign_bool_exp!]!) {
    delete_sales_assign(where: { _or: $conditions }) {
      affected_rows
    }
  }
`;

export const ADD_DVR_COMMENT = gql`
  mutation insert_dvr_comments($objects: [dvr_comments_insert_input!]!) {
    insert_dvr_comments(objects: $objects) {
      returning {
        id
      }
    }
  }
`;

export const UPDATE_DVR_COMMENT = gql`
  mutation update_dvr_comments($id: uuid!, $comment: String) {
    update_dvr_comments(
      where: { id: { _eq: $id } }
      _set: { comment: $comment }
    ) {
      affected_rows
    }
  }
`;

export const GET_NEW_DEALER_REQUEST = gql`
  {
    new_dealer_requests(order_by: { request_date: desc }) {
      id
      dealer_name
      legal_name
      address
      address2
      city
      region
      country
      zipcode
      delivery_address
      delivery_address2
      delivery_city
      delivery_region
      delivery_country
      delivery_zipcode
      mailing_address
      mailing_address2
      mailing_city
      mailing_region
      mailing_country
      mailing_zipcode
      business_phone1
      business_phone2
      business_fax
      business_cell
      business_other
      business_email
      business_sales_email
      business_website
      contact_name_1
      contact_title_1
      contact_name_2
      contact_title_2
      boat_brands_sold
      outboard_brands
      bank_name
      bank_account
      bank_contact
      bank_business_type
      bank_state
      bank_taxid
      bank_resale_taxid
      supplier_name_1
      supplier_phone_1
      supplier_address_1
      supplier_city_1
      supplier_region_1
      supplier_zipcode_1
      supplier_contact_1
      supplier_account_1
      supplier_name_2
      supplier_phone_2
      supplier_address_2
      supplier_city_2
      supplier_region_2
      supplier_zipcode_2
      supplier_contact_2
      supplier_account_2
      dealer_signature
      fulfilledby
      fulfilledon
      request_date
      seachaser
      carolinaskiff
      sales_assign
      profile {
        company
      }
    }
  }
`;

export const GET_NEW_DEALER_REQUEST_SALES = gql`
  subscription new_dealer_requests($profileIds: [String!]!) {
    new_dealer_requests(
      where: { sales_assign: { _in: $profileIds } }
      order_by: { request_date: desc }
    ) {
      id
      legal_name
      business_email
      business_phone1
      mailing_address
      mailing_address2
      mailing_city
      mailing_country
      mailing_zipcode
      request_date
      seachaser
      carolinaskiff
      fulfilledby
      fulfilledon
      sales_assign
      profile {
        profile_id
        company
        name
        email
        has_skiff
        has_seachaser
        has_funchaser
        email
        address
        address2
        city
        zipcode
        country
        region
        phone
      }
      new_dealer_requests_comments {
        id
        comment
        created_at
        profile {
          company
        }
      }
    }
  }
`;

export const ADD_NEW_REQUEST_COMMENT = gql`
  mutation insert_new_dealer_requests_comment(
    $objects: [new_dealer_requests_comment_insert_input!]!
  ) {
    insert_new_dealer_requests_comment(objects: $objects) {
      returning {
        id
      }
    }
  }
`;

export const ADD_NEW_REQUEST_COMMENT_NOTIFICATION = gql`
  mutation insert_user_notification(
    $objects: [user_notification_insert_input!]!
  ) {
    insert_user_notification(objects: $objects) {
      affected_rows
    }
  }
`;

export const GET_SALES_SURVEY_RATING = gql`
  query survey_rating_aggregate($profileId: [String!]!) {
    survey_rating_aggregate(where: { profile_id: { _in: $profileId } }) {
      profile_id
      dealer_name
      rating
    }
  }
`;

export const GET_SALES_SURVEY = gql`
  query survey($profileId: [String!]!) {
    survey(
      order_by: { survey_date: desc }
      where: { profile_id: { _in: $profileId } }
    ) {
      id
      profile_id
      dealer_name
      first_name
      last_name
      warranty_id
      first_new_boat
      consider_brands
      consider_brands_yes
      when_right_boat
      first_see_boat
      deciding_factor
      people_on_boat
      use_new_boat
      plan_to_use_new_boat
      water_type_usage
      own_another_boat
      sales_experience
      refer_selling_dealer
      satisfied_model_selection
      satisfied_professionalism
      satisfied_cleanliness
      dealer_explanation
      time_complete_purchase
      new_boat_serviced
      delivery_process
      features_explanation
      dealership_tour
      parts_manager
      service_manager
      answer_questions
      knowledgeable
      sea_trial
      on_water_delivery
      dealer_warranty
      explain_sea_trial
      follow_up
      comments
      survey_date
      satisfied_boat_overall
      satisfied_boat_performance
      satisfied_boat_price
      satisfied_boat_finish
    }
  }
`;

export const GET_ASSIGNED_DEALERS_BY_REGION = gql`
  query sales_assign($regions: [String!]!) {
    sales_assign(where: { assign_profiles: { region: { _in: $regions } } }) {
      assign_user_id
      profile_id
      regions
    }
  }
`;
